
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import Tile from '../../components/Tile';
import { FaFileContract, FaClock, FaCalendarCheck } from 'react-icons/fa';

const tiles = [
  {
    title: 'Prawo pracy w pigułce',
    description: 'Twoje prawa i obowiązki w świetle przepisów.',
    icon: <FaFileContract />,
    to: '/rights/laborlaw',
  },
  {
    title: 'Czas pracy',
    description: 'Ile godzin powinieneś pracować?',
    icon: <FaClock />,
    gradient: 'pink',
    to: '/rights/worktime',
  },
  {
    title: 'Dni ustawowo wolne',
    description: 'Kiedy nie musisz brać urlopu, bo i tak masz wolne.',
    icon: <FaCalendarCheck />,
    gradient: 'purple',
    to: '/rights/holidays',
  },
];


const Rights = () => {
  const navigate = useNavigate();
  const handleTileClick = (to) => {
    navigate(to);
  };


  return (
    <Container className="py-4">
      <h1 className="mb-4 fw-bold text-center">Twoje prawa</h1>
      <Row className="g-4 justify-content-center">
        {tiles.map((tile, idx) => (
          <Col key={tile.title} xs={12} sm={6} md={4} lg={3}>
            <Tile {...tile} onClick={() => handleTileClick(tile.to)} />
          </Col>
        ))}

      </Row>
      {/* Stonowane, pastelowe, nieklikalne teksty w stylu Bootstrap */}
      <div className="rights-scramble-text-soft">
        <span className="rights-soft-item rights-soft-1">Sprawdź!</span>
        <span className="rights-soft-item rights-soft-2">Do czego masz prawo?</span>
        <span className="rights-soft-item rights-soft-3">Jak to jest z czasem pracy?</span>
        <span className="rights-soft-item rights-soft-4">Kiedy należy Ci się dzień wolny, a kiedy ma Ci go oddać pracodawca?</span>
        <span className="rights-soft-item rights-soft-5">Ile uczeń może odpoczywać w czasie pracy?</span>
      </div>
      <style>{`
        .rights-scramble-text-soft {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          align-items: flex-end;
          gap: 1.5rem 2.5rem;
          margin-top: 2.5rem;
          margin-bottom: 1.5rem;
          font-family: inherit;
          font-size: clamp(1.2rem, 2.2vw, 1.5rem);
          min-height: 8rem;
          position: relative;
        }
        .rights-soft-item {
          display: inline-block;
          padding: 0.5rem 1.2rem;
          margin: 0.2rem 0.5rem;
          border-radius: 0.6rem;
          background: #f8f9fa;
          color: #343a40;
          font-weight: 500;
          letter-spacing: 0.01em;
          box-shadow: 0 2px 8px 0 #dee2e6;
          border: 1px solid #e9ecef;
          user-select: text;
          cursor: default;
          transition: background 0.2s, color 0.2s;
        }
        .rights-soft-1 { background: #e3f2fd; color: #1565c0; }
        .rights-soft-2 { background: #e8f5e9; color: #388e3c; }
        .rights-soft-3 { background: #fff3e0; color: #f57c00; }
        .rights-soft-4 { background: #ede7f6; color: #512da8; }
        .rights-soft-5 { background: #fce4ec; color: #ad1457; }
        @media (max-width: 600px) {
          .rights-scramble-text-soft {
            flex-direction: column !important;
            align-items: center !important;
            gap: 0.7rem 0 !important;
            font-size: 1.08rem !important;
            min-height: unset !important;
          }
          .rights-soft-item {
            margin: 0.22rem 0 !important;
            padding: 0.45rem 0.9rem !important;
            border-radius: 0.5rem !important;
            font-size: 1.08rem !important;
            text-align: center;
            width: 100%;
            max-width: 95vw;
            box-sizing: border-box;
            word-break: break-word;
          }
        }
      `}</style>
    </Container>
    );
  };

export default Rights;
